<template>
  <md-card-content>
    <!-- 申し込みのきっかけ -->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>申し込みのきっかけ</label>
      </div>
      <div class="md-layout-item md-size-30 md-small-size-100">
        <md-field>
          <label>{{ form.contract.reason }}</label>
        </md-field>
      </div>
    </div>
  </md-card-content>
</template>

<script>
export default {
  name : 'ContractPreviewEtc',
  props: ['form'],
}
</script>

<style lang="scss" scoped>
</style>
